import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const makeBackup = (params, urlParams) => {
  return axios.request({
    url: '/ops/backupdb/makebackup' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getChildrenFileList = (params, urlParams) => {
  return axios.request({
    url: '/ops/backupdb/getchildrenfilelist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const removeFile = (params, urlParams) => {
  return axios.request({
    url: '/ops/backupdb/removefile' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

